import { User as ConfigCatUser } from 'configcat-js';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PLAuthSuccess } from 'pl-core-services';
import { tap } from 'rxjs';
import { FeatureFlagService } from '../services/feature-flag.service';

@Injectable()
export class PLFeatureFlagEffects {
  checkAccountsStatus = createEffect(
    () =>
      this.actions$.pipe(
        ofType(PLAuthSuccess),
        tap(({ user }) => {
          this.featureFlagService.identifyUser(
            new ConfigCatUser(user.uuid, user.email, null, {
              username: user.username,
            })
          );
        })
      ),
    {
      dispatch: false,
    }
  );

  constructor(
    private actions$: Actions,
    private featureFlagService: FeatureFlagService
  ) {}
}
